import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import evaluationIcon from '../../../assets/evaluar.svg';
import paperIcon from '../../../assets/hoja-check.svg';
import imagenHombre from '../../../assets/imagen-hombre.png';
import clockIcon from '../../../assets/reloj-circular.svg';
import { getCurrentStateByUser } from '../../../services/mentoriaService';
import Loader from '../../../shared/src/components/atoms/loader/loader';
import authContext from '../../../shared/src/contexts/authContext';
import Button from '../../atoms/button/button';
import './diagnosticoStart.scss';

const DiagnosticoStart = () => {
	const auth = useContext(authContext)
	const [loading, setLoading] = useState(true)
	const navigate = useNavigate();

	useEffect(() => {
		if (auth.gigyaAccount) {
				getCurrentStateByUser()
					.then((res) => {
						if (!res?.data?.data?.hasPurpose) {
							navigate('/');
						}
					})
			.catch(error => console.error(error))
				.finally(() => {
					setLoading(false);
				})
		}
	}, [auth.gigyaAccount])

	if (loading) {
		return (<Loader />)
	}

	return (
		<div className='diagnostico-container'>
			<section className='diagnostico-container__header'>
				<div className="diagnostico-container__header__title">
					<h1>Diagnóstico</h1>
					<h4>¿Conoces el estado de tus finanzas?</h4>
					<p>En Comfama queremos ayudarte para que mejores el manejo de tu dinero, de forma que puedas organizar y alcanzar tus propósitos.</p>
				</div>
			</section>
			<div className='diagnostico-container__body'>
				<section className='diagnostico-container__info'>
					<div className='diagnostico-container__info__box'>
						<img src={evaluationIcon} alt="Icono autoevaluación"></img>
						<div className='diagnostico-container__info__box__text'>
							<h3>Autoevaluación</h3>
							<p>Esto es para que te autoevalúes. Comfama no utilizará esta información para asignación de subsidios.</p>
						</div>
					</div>
					<div className='diagnostico-container__info__box'>
						<img src={clockIcon} alt="Icono tiempo"></img>
						<div className='diagnostico-container__info__box__text'>
							<h3>Tiempo</h3>
							<p>Te tomará menos de 12 minutos</p>
						</div>
					</div>
					<div className='diagnostico-container__info__box'>
						<img src={paperIcon} alt="Icono respuestas"></img>
						<div className='diagnostico-container__info__box__text'>
							<h3>Responde con sinceridad</h3>
							<p>Esto nos permitirá darte la orientación indicada.</p>
						</div>
					</div>
				</section>
				<div className="diagnostico-container__img-container">
					<img src={imagenHombre} alt="Queremos conocerte"></img>
					<div className='diagnostico-container__img-container__button-border'>
						<Button text="Comenzar" gtmClass='secondary' onClick={() => navigate('/formulario-salud-educacion-financiera/preguntas')} />
					</div>
				</div>
			</div>
			<div className="diagnostico-container__img-container__button-border-desktop__center">
				<div className='diagnostico-container__img-container__button-border-desktop'>
					<Button text="Comenzar" gtmClass='secondary' onClick={() => navigate('/formulario-salud-educacion-financiera/preguntas')} />
				</div>
			</div>
		</div>
	)
}

export default DiagnosticoStart